import React, { ReactNode } from 'react';
import styles from './styles.module.scss';
import cN from 'classnames';

import { ArrowRightIcon } from '@features/ui/Icons';

interface I_Notification {
    noticeType: string;
    icon: ReactNode;
    content: string;
    link: string;
    linkText: string;
    color: 'blue' | 'red';
}
const Notification = (props: I_Notification) => {
    const moduleName = 'notice';

    const { noticeType, icon, content, color, link, linkText } = props;

    return (
        <div className={cN(moduleName, styles[moduleName])}>
            <div className={cN(styles.title, styles[color])}>
                {icon}
                {/* 顔色區塊 */}
                <span>{noticeType}</span>
            </div>
            <div className={styles.wrap}>
                <div className={styles.content}>
                    {/* 中間黑字 */}
                    {content}
                </div>
                <a
                    className={styles.more}
                    // 網址
                    href={link}
                    target="_blank"
                    rel="noreferrer noopener"
                >
                    {/* 連結文字 */}
                    {linkText}
                    <ArrowRightIcon fill="#3ea5d9" />
                </a>
            </div>
        </div>
    );
};

export default Notification;
